/* NS MOTION product hero: one muted preview video, with size-matched rendition, accessible controls,
   autoplay fallback, reduced-motion / data-saver respect, and Theme Editor live re-init. */
(function () {
  'use strict';

  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var saveData = !!(navigator.connection && navigator.connection.saveData);

  function pick(list, targetWidth) {
    // list is sorted by width ascending. Smallest rendition that is at least targetWidth wide.
    for (var i = 0; i < list.length; i++) {
      if (list[i].w >= targetWidth) return list[i];
    }
    return list[list.length - 1];
  }

  function init(root) {
    if (!root || root.getAttribute('data-mp-ready') === '1') return;
    var video = root.querySelector('video');
    if (!video) return;
    root.setAttribute('data-mp-ready', '1');

    var all = [];
    try { all = JSON.parse(root.getAttribute('data-sources') || '[]'); } catch (e) { all = []; }
    var mp4s = all.filter(function (s) { return s.t === 'mp4'; }).sort(function (a, b) { return a.w - b.w; });
    var hls = all.filter(function (s) { return s.t === 'hls'; })[0];
    var hlsOk = !!(hls && (video.canPlayType('application/vnd.apple.mpegurl') || video.canPlayType('application/x-mpegURL')));
    var hlsFailed = false;

    var wantsAutoplay = root.getAttribute('data-autoplay') === 'true';
    var wantsLoop = root.getAttribute('data-loop') === 'true';
    var wantsControls = root.getAttribute('data-controls') === 'true';
    var toggleBtn = root.querySelector('[data-mp-toggle]');
    var fullBtn = root.querySelector('[data-mp-full]');
    var bigPlay = root.querySelector('[data-mp-bigplay]');
    var userPaused = false;
    var currentUrl = '';

    video.muted = true;
    video.defaultMuted = true;
    video.loop = wantsLoop;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    function setSrc(url) {
      if (!url || url === currentUrl) return;
      var t = currentUrl ? video.currentTime : 0;
      var resume = currentUrl ? !video.paused : false;
      currentUrl = url;
      video.src = url;
      video.load();
      if (t > 0) {
        video.addEventListener('loadedmetadata', function once() {
          video.removeEventListener('loadedmetadata', once);
          try { video.currentTime = t; } catch (e) {}
          if (resume) play();
        });
      }
    }

    function choose(targetWidth) {
      // Adaptive HLS where the browser plays it natively (iPhone / Safari); otherwise the smallest MP4 that fits the panel.
      if (hlsOk && !hlsFailed) return hls.url;
      if (mp4s.length) return pick(mp4s, targetWidth).url;
      return '';
    }

    function chooseForPanel() {
      var w = root.getBoundingClientRect().width || 200;
      setSrc(choose(w));
    }

    function setState(playing) {
      root.classList.toggle('is-paused', !playing);
      root.classList.toggle('is-playing', playing);
      if (toggleBtn) {
        toggleBtn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
        toggleBtn.setAttribute('aria-pressed', playing ? 'false' : 'true');
      }
    }

    function play() {
      video.muted = true;
      var p = video.play();
      if (p && p.then) {
        p.then(function () { setState(true); }).catch(function () { setState(false); });
      } else {
        setState(!video.paused);
      }
    }

    function pause() { video.pause(); setState(false); }

    video.addEventListener('playing', function () { root.classList.add('is-ready'); setState(true); });
    video.addEventListener('pause', function () { setState(false); });
    video.addEventListener('loadeddata', function () { root.classList.add('is-ready'); });
    video.addEventListener('loadedmetadata', function () { root.classList.add('is-ready'); });
    video.addEventListener('error', function () {
      // If native HLS fails, fall back to an MP4 rather than leaving a dead panel.
      if (hlsOk && !hlsFailed && mp4s.length) {
        hlsFailed = true;
        currentUrl = '';
        chooseForPanel();
        if (wantsAutoplay && !reduceMotion && !saveData) play();
        return;
      }
      root.classList.add('is-ready');
      setState(false);
    });

    if (toggleBtn) {
      toggleBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (video.paused) { userPaused = false; play(); } else { userPaused = true; pause(); }
      });
    }
    if (bigPlay) {
      bigPlay.addEventListener('click', function (e) {
        e.stopPropagation();
        userPaused = false;
        play();
      });
    }
    if (wantsControls) {
      // Tapping the picture itself also toggles play / pause.
      video.addEventListener('click', function () {
        if (video.paused) { userPaused = false; play(); } else { userPaused = true; pause(); }
      });
    }

    function exitFull() {
      video.controls = false;
      chooseForPanel();
    }
    if (fullBtn) {
      fullBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        setSrc(choose(Math.min(window.innerWidth, 420)));
        video.controls = true;
        var req = video.requestFullscreen || video.webkitRequestFullscreen || video.msRequestFullscreen;
        if (req) {
          try { var r = req.call(video); if (r && r.catch) r.catch(function () {}); } catch (err) {}
        } else if (video.webkitEnterFullscreen) {
          try { video.webkitEnterFullscreen(); } catch (err2) {}
        }
        if (video.paused) { userPaused = false; play(); }
      });
    }
    document.addEventListener('fullscreenchange', function () { if (!document.fullscreenElement) exitFull(); });
    document.addEventListener('webkitfullscreenchange', function () { if (!document.webkitFullscreenElement) exitFull(); });
    video.addEventListener('webkitendfullscreen', exitFull);

    // Load the right rendition, then start (or wait for a tap).
    chooseForPanel();
    setState(false);
    var canAuto = wantsAutoplay && !reduceMotion && !saveData;
    if (canAuto) { play(); }

    // Pause when scrolled out of view / tab hidden to save battery; resume only if the visitor didn't pause it.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!canAuto || userPaused) return;
          if (en.isIntersecting) { if (video.paused) play(); } else if (!video.paused) { video.pause(); }
        });
      }, { threshold: 0.15 });
      io.observe(root);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { if (!video.paused) video.pause(); }
      else if (canAuto && !userPaused && video.paused) { play(); }
    });
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-mp-video]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  // Theme Editor: re-initialise when the section is re-rendered after a setting change.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
